import { nanoid } from "nanoid";
import { FilterCombinationPayload, FilterPayload } from "../../../datasources/api-client/data-contracts";
import { FilterItem, GroupFilter } from "../types";

const mapPayloadToRow = (filter: FilterPayload): FilterItem => {
	return {
		type: "row",
		value: {
			id: nanoid(),
			filter: filter.id,
			operator: filter.operator,
			value: filter.value,
		},
	};
};

// Converts a saved filter payload (backend format) into a UI group structure.
//
// Important behavior notes:
// - Only flat filters are considered (no nested groups supported here)
// - Everything is normalized into a single AND group
// - Each filter becomes a UI row with a generated local id
// - This is used for restoring saved filters into the dashboard/editor
export const savedFilterToGroup = (query: FilterCombinationPayload): GroupFilter => {
	const rows: FilterItem[] = query.filters
		? query.filters.filter((item): item is FilterPayload => "id" in item).map(mapPayloadToRow)
		: [];

	return {
		id: nanoid(),
		rowOperator: "and",
		rows,
	};
};
